import React, { useState, useEffect } from "react";
import { setAlert } from "action";
import checkIcon from "assets/images/images_new/check_circle.svg";
import AcceptCard from "assets/images/images_new/accept-card.svg";
import ReactHtmlParser from 'react-html-parser';
import cancelIcon from "assets/images/images_new/cancel.svg";


import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Card,
  CardTitle,
  CardText,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import API from "api.js";
import ListAndBuy from "components/Plans/CCAvenue/ListAndBuy";
import StripeCards from "components/Payments/Stripe/StripeCards";
import GoldImg from "assets/images/images_new/gold-icon.svg";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";
import { useDispatch } from "react-redux";

const CARD = "CARD";
const UPI = "UPI";
export default function SelectPaymentMethod({
  stripeForm,
  country,
  isGold,
  selectedMethod,
  plan,
  discount,
  prorationSubtotal,
  paymentMethod,
  loading,
  makePayment,
  onUpiLoadingChange
}) {

  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(CARD);
  const [plans, setPlans] = useState([]);
  const [upiLoading, setUpiLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  console.log("plans==",plans);
  

  const tabToggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const loadUPIPlans = () => {
    let url = `getCcavPackages?countryId=${country}`;
    if (import.meta.env.VITE_ENV === "production") {
      url = `https://ipbackend22.languageacademy.com.au/api/v2/getCcavPackages?countryId=${country}`;
    }

    setUpiLoading(true);
    onUpiLoadingChange?.(true);
    API({
      url,
      method: "GET",
    })
      .then(({ data }) => {
        const selected_plans = [];

        data.plans.map((plan) => {
          if (plan.is_gold === isGold) {
            selected_plans.push(plan);
          }
        });
        setPlans(selected_plans);
      })
      .catch((err) => {
        dispatch(
        setAlert({ flag: true, type: 2, message: "Something went wrong." })
        );
        console.log("err:", err)})
      .finally(() => {
        setUpiLoading(false);
        onUpiLoadingChange?.(false);
      });
  };

  /**
   * Use this for CCAVENUE plans.
   * Comment this block when using RazorPay Plans.
   */
  useEffect(() => {
    if (isGold !== undefined) {
      loadUPIPlans();
    }
  }, [isGold]);

  useEffect(() => {
    selectedMethod(activeTab);
  }, [activeTab]);


  const billedLabel = ({ duration }) => {
    let label = "";
    if (duration !== undefined) {
      switch(duration) {
      case 1:
        label = "Monthly";
        break;
      default:
        label = `Every ${duration} Months`;
        break
      }
    }

    return label;
  }

  const tabMenu = () => {
    let tabs = "";
    
    if (country === "IN") {
      tabs = (
        <div className="payment-options tabs-content mb-3 pl-0">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={`${activeTab === CARD ? "active" : ""}`}
                onClick={() => { tabToggle(CARD) }}
              >
                Card
                {/* Credit/Debit Card */}
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`${activeTab === UPI ? "active" : ""}`}
                onClick={() => { tabToggle(UPI) }}
              >Pay with UPI</NavLink>
            </NavItem>
          </Nav>
        </div>
      );
    }

    return tabs;
  }

  const showCorrectPrice = () => {
    return activeTab === CARD ? plan.price : plan.razorpay_price;
  }

  return (
    <div className="transation-page outer-wrapper">
     {
      loading || upiLoading || isLoading ? (
        <Spinner/>
      ) : (
         <div className="row">
       
        <div className="col-md-6">
          <div className="payment-card">
            {tabMenu()}
 
            <h2 className="title">Payment Summary</h2>
            {/* <p className="payment-title">Billing Plan</p>
 
            <div className="billing-card">
              <p>Billed {billedLabel(plan)}</p>
              <p className="price">{ReactHtmlParser(plan.currency)} {showCorrectPrice()}</p>
              <p className="per-month">{plan.duration} month</p>
              {plan.is_gold==1 && <img className="payment-gold-img" src={GoldImg} alt="LA" />}
            </div>
            <p className="form-payment-title">
              Payment Details <img src={secureIcon} alt="LA" />
            </p> */}
 
            <TabContent activeTab={activeTab}>
              <TabPane tabId={CARD} className="visibility-visible">
                {/* OLD STRIPE FORM - COMMENTED OUT
                <form className="payment-card-form">
                  <div className="input-wrapper">{stripeForm()}</div>
                  <p className="form-text">
                    By providing your card information, you allow Language Academy
                    to charge your card for future payments in accordance with their
                    terms.
                  </p>
                </form>
                */}
                {/* NEW STRIPE HOSTED CHECKOUT */}
               
                {/* <div className="payment-card-form">
                  <Button
                    className="btn btn-primary btn-lg w-100"
                    onClick={makePayment}
                  >
                    Proceed to Checkout
                  </Button>
                  <p className="form-text mt-3">
                    You will be redirected to Stripe's secure checkout page to complete your payment.
                  </p>
                </div> */}
                <StripeCards
                  plan={plan}
                  isGold={isGold}
                  makePayment={makePayment}
                />
              </TabPane>
 
              <TabPane tabId={UPI} className="visibility-visible">
                <ListAndBuy
                  plans={plans}
                  plan={plan}
                  isGold={isGold}
                  setLoading={setIsLoading}
                  loading={isLoading}
                />
              </TabPane>
            </TabContent>
          </div>
        </div>
 
        <div className="col-md-6">
          <div className="payment-card package-content">
            <h2 className="title">Package Benefits</h2>
 
            <ul className="package-list">
              {plan.is_gold == 1 ? (
                <>
                  <li>
                    <img src={checkIcon} alt="LA" /> Duration {plan.duration} Month(s)
                  </li>
                  <li>
                    <img src={checkIcon} alt="LA" /> Unlimited AI scoring for all question types
                  </li>
                  <li><img src={checkIcon} alt="LA" /> Full access to them exam questions</li>
                  <li><img src={checkIcon} alt="LA" /> Access to latest templates and prediction files</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited sectional mock tests with scoring</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited full mock tests with scoring</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited comprehensive mock tests with scoring</li>
                  <li><img src={checkIcon} alt="LA" /> Access to reading explanation videos</li>
                  <li><img src={checkIcon} alt="LA" /> Full access to premium strategy videos</li>
                  <li><img src={checkIcon} alt="LA" /> Full access to the detailed video course
                  </li>
                </>
              ) : (
                <>
                  <li><img src={checkIcon} alt="LA" /> Duration {plan.duration} Month(s)</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited AI scoring for all question types</li>
                  <li><img src={checkIcon} alt="LA" /> Full access to the exam questions</li>
                  <li><img src={checkIcon} alt="LA" /> Access to latest templates and prediction files</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited sectional mock tests with scoring</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited full mock tests with scoring</li>
                  <li><img src={checkIcon} alt="LA" /> Unlimited comprehensive mock tests with scoring</li>
                  <li className="cencel-list"><img src={cancelIcon} alt="LA" /> Access to reading explanation videos</li>
                  <li className="cencel-list"><img src={cancelIcon} alt="LA" /> Full access to premium strategy videos</li>
                  <li className="cencel-list"><img src={cancelIcon} alt="LA" /> Full access to the detailed video course</li>
                </>
              )}
            </ul>
           {activeTab === CARD && 
           (
              <div className="accept-cards">
              <p>We accept the following card</p>
              <img src={AcceptCard} alt="LA" />
            </div>
           )
           }
          
          </div>
        </div>
      </div>
      )
     }
    </div>
  );

  // return (
  // 	<div className="panel panel-default">
  // 		{/*<h2 className="paymentFormTitle">Select a payment method</h2>*/}

  // 		<div className="">
  // 			{country === "IN" &&
  // 				<Nav tabs>
  // 					<NavItem>
  // 						<NavLink
  // 							className={`btn btn-primary btn-lg ${activeTab === CARD ? "active" : ""}`}
  // 							onClick={() => { tabToggle(CARD) }}
  // 						>Credit/Debit Card</NavLink>
  // 					</NavItem>
  // 					<NavItem>
  // 						<NavLink
  // 							className={`btn btn-primary btn-lg ${activeTab === UPI ? "active" : ""}`}
  // 							onClick={() => { tabToggle(UPI) }}
  // 						>Pay with UPI</NavLink>
  // 					</NavItem>
  // 				</Nav>
  // 			}
  // 			<TabContent activeTab={activeTab}>
  // 				<TabPane tabId={CARD}>
  // 					<Row className="mt-3">
  // 						<Col sm="12">
  // 							<Card body>
  // 								{stripeForm()}
  // 							</Card>
  // 						</Col>
  // 					</Row>
  // 				</TabPane>
  // 				<TabPane tabId={UPI}>
  // 					<Row className="mt-3">
  // 						<Col sm="12">
  // 							<Card body className="payCardsOuter">
  // 								<ListAndBuy
  // 									plans={plans}
  // 									plan={plan}
  // 									isGold={isGold}
  // 								/>

  // 								{/*Comment Below code When using RazorPay*/}
  // 								{/* <Row>
  // 									<Col sm="6">
  // 										<div className="text-danger pull-left mb-0" style={{fontSize: "12px"}}>* Prices inclusive of all taxes.</div>
  // 										<br /><div className="text-danger" style={{fontSize: "12px", marginTop: "-5px"}}>* One-time Purchase.</div>
  // 									</Col>
  // 									<Col sm="6">
  // 										<p className="pull-right" style={{fontSize: "12px"}}>
  // 											<Link
  // 												to="/admin/ccav/plans"
  // 												className="text-info"
  // 											>Explore all UPI Plans</Link>
  // 										</p>
  // 									</Col>
  // 								</Row> */}
  // 								{/*Till here.*/}

  // 							</Card>
  // 						</Col>
  // 					</Row>
  // 				</TabPane>
  // 			</TabContent>
  // 		</div>
  // 	</div>
  // );
}
